import { services } from '@broadleaf/admin-components';
import GridEntityForm from 'app/common/components/GridEntityForm/GridEntityForm';

const { ComponentRegistrar } = services;

ComponentRegistrar.registerComponent('AURORA_GRID_ENTITY_FORM', GridEntityForm);
ComponentRegistrar.registerViewComponent(
  'AURORA_GRID_ENTITY_FORM',
  GridEntityForm
);
